
import { AlertTriangle } from "lucide-react";

interface ErrorNotificationProps {
  error: string | null;
}

export const ErrorNotification = ({ error }: ErrorNotificationProps) => {
  if (!error) return null;
  
  return (
    <div className="mb-6 p-4 border border-yellow-200 bg-yellow-50 rounded-md">
      <div className="flex items-center gap-2 mb-2">
        <AlertTriangle className="h-5 w-5 text-yellow-500" />
        <p className="font-medium text-yellow-700">Note</p>
      </div>
      <p className="text-yellow-600 mb-4">{error}</p>
    </div>
  );
};
